export default {"src":"/_next/static/media/icon-500.34680944.svg","height":168,"width":381,"blurWidth":0,"blurHeight":0};